
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/women",
      function () {
        return require("private-next-pages/women/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/women"])
      });
    }
  